/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../app/app.module';
import * as import2 from '@angular/common';
import * as import3 from '@angular/router';
import * as import4 from '@angular/platform-browser';
import * as import5 from '@angular/forms';
import * as import6 from '@angular/http';
import * as import7 from '../../app/shared/shared.module';
import * as import8 from '@angular/material';
import * as import9 from '@angular/platform-browser/animations';
import * as import10 from '../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as import11 from './not-found/not-found.component.ngfactory';
import * as import12 from './app.component.ngfactory';
import * as import13 from '../../app/not-found/not-found.component';
import * as import14 from '@angular/animations/browser';
class AppModuleInjector extends import0.ɵNgModuleInjector<import1.AppModule> {
  _CommonModule_0:import2.CommonModule;
  _ErrorHandler_1:any;
  _NgProbeToken_2:any[];
  _ɵg_3:import3.ɵg;
  _APP_INITIALIZER_4:any[];
  _ApplicationInitStatus_5:import0.ApplicationInitStatus;
  _ɵf_6:import0.ɵf;
  _ApplicationRef_7:any;
  _ApplicationModule_8:import0.ApplicationModule;
  _BrowserModule_9:import4.BrowserModule;
  _ɵba_10:import5.ɵba;
  _FormsModule_11:import5.FormsModule;
  _HttpModule_12:import6.HttpModule;
  _SharedModule_13:import7.SharedModule;
  _ɵa_14:any;
  _UrlSerializer_15:import3.DefaultUrlSerializer;
  _RouterOutletMap_16:import3.RouterOutletMap;
  _ROUTER_CONFIGURATION_17:any;
  _LocationStrategy_18:any;
  _Location_19:import2.Location;
  _Compiler_20:import0.Compiler;
  _NgModuleFactoryLoader_21:import0.SystemJsNgModuleLoader;
  _ROUTES_22:any[];
  _Router_23:any;
  _RouterModule_24:import3.RouterModule;
  _CompatibilityModule_25:import8.CompatibilityModule;
  _MdRippleModule_26:import8.MdRippleModule;
  _MdSelectionModule_27:import8.MdSelectionModule;
  _MdOptionModule_28:import8.MdOptionModule;
  _PortalModule_29:import8.PortalModule;
  _OverlayModule_30:import8.OverlayModule;
  _MdAutocompleteModule_31:import8.MdAutocompleteModule;
  _StyleModule_32:import8.StyleModule;
  _MdButtonModule_33:import8.MdButtonModule;
  _MdCardModule_34:import8.MdCardModule;
  _MdChipsModule_35:import8.MdChipsModule;
  _MdCheckboxModule_36:import8.MdCheckboxModule;
  _MdLineModule_37:import8.MdLineModule;
  _MdGridListModule_38:import8.MdGridListModule;
  _PlatformModule_39:import8.PlatformModule;
  _MdInputModule_40:import8.MdInputModule;
  _MdListModule_41:import8.MdListModule;
  _MdProgressBarModule_42:import8.MdProgressBarModule;
  _MdProgressSpinnerModule_43:import8.MdProgressSpinnerModule;
  _MdSelectModule_44:import8.MdSelectModule;
  _A11yModule_45:import8.A11yModule;
  _MdSidenavModule_46:import8.MdSidenavModule;
  _ObserveContentModule_47:import8.ObserveContentModule;
  _MdTabsModule_48:import8.MdTabsModule;
  _MdToolbarModule_49:import8.MdToolbarModule;
  _RtlModule_50:import8.RtlModule;
  _MdButtonToggleModule_51:import8.MdButtonToggleModule;
  _MdDialogModule_52:import8.MdDialogModule;
  _MdIconModule_53:import8.MdIconModule;
  _MdMenuModule_54:import8.MdMenuModule;
  _MdRadioModule_55:import8.MdRadioModule;
  _MdSliderModule_56:import8.MdSliderModule;
  _MdSlideToggleModule_57:import8.MdSlideToggleModule;
  _MdSnackBarModule_58:import8.MdSnackBarModule;
  _MdTooltipModule_59:import8.MdTooltipModule;
  _MaterialRootModule_60:import8.MaterialRootModule;
  _BrowserAnimationsModule_61:import9.BrowserAnimationsModule;
  _AppModule_62:import1.AppModule;
  __LOCALE_ID_63:any;
  __NgLocalization_64:import2.NgLocaleLocalization;
  __APP_ID_65:any;
  __IterableDiffers_66:any;
  __KeyValueDiffers_67:any;
  __DomSanitizer_68:import4.ɵe;
  __Sanitizer_69:any;
  __HAMMER_GESTURE_CONFIG_70:import8.GestureConfig;
  __EVENT_MANAGER_PLUGINS_71:any[];
  __EventManager_72:import4.EventManager;
  __ɵDomSharedStylesHost_73:import4.ɵDomSharedStylesHost;
  __ɵDomRendererFactory2_74:import4.ɵDomRendererFactory2;
  __AnimationDriver_75:any;
  __ɵAnimationStyleNormalizer_76:any;
  __ɵAnimationEngine_77:import9.ɵa;
  __RendererFactory2_78:any;
  __ɵSharedStylesHost_79:any;
  __Testability_80:import0.Testability;
  __Meta_81:import4.Meta;
  __Title_82:import4.Title;
  __ɵi_83:import5.ɵi;
  __BrowserXhr_84:import6.BrowserXhr;
  __ResponseOptions_85:import6.BaseResponseOptions;
  __XSRFStrategy_86:any;
  __XHRBackend_87:import6.XHRBackend;
  __RequestOptions_88:import6.BaseRequestOptions;
  __Http_89:any;
  __ScrollDispatcher_90:any;
  __ɵh_91:any;
  __OverlayContainer_92:any;
  __ɵk_93:import8.ɵk;
  __Overlay_94:import8.Overlay;
  __FocusOriginMonitor_95:any;
  __Platform_96:import8.Platform;
  __InteractivityChecker_97:import8.InteractivityChecker;
  __FocusTrapFactory_98:import8.FocusTrapFactory;
  __LiveAnnouncer_99:any;
  __UniqueSelectionDispatcher_100:any;
  __MdDialog_101:import8.MdDialog;
  __MdIconRegistry_102:any;
  __MdSnackBar_103:import8.MdSnackBar;
  __ActivatedRoute_104:any;
  __NoPreloading_105:import3.NoPreloading;
  __PreloadingStrategy_106:any;
  __RouterPreloader_107:import3.RouterPreloader;
  __PreloadAllModules_108:import3.PreloadAllModules;
  __ROUTER_INITIALIZER_109:any;
  __APP_BOOTSTRAP_LISTENER_110:any[];
  constructor(parent:import0.Injector) {
    super(parent,[
      import10.MdDialogContainerNgFactory,
      import10.MdSnackBarContainerNgFactory,
      import10.SimpleSnackBarNgFactory,
      import10.TooltipComponentNgFactory,
      import11.NotFoundComponentNgFactory,
      import12.AppComponentNgFactory
    ]
    ,[import12.AppComponentNgFactory]);
  }
  get _LOCALE_ID_63():any {
    if ((this.__LOCALE_ID_63 == null)) { (this.__LOCALE_ID_63 = import0.ɵn(this.parent.get(import0.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_63;
  }
  get _NgLocalization_64():import2.NgLocaleLocalization {
    if ((this.__NgLocalization_64 == null)) { (this.__NgLocalization_64 = new import2.NgLocaleLocalization(this._LOCALE_ID_63)); }
    return this.__NgLocalization_64;
  }
  get _APP_ID_65():any {
    if ((this.__APP_ID_65 == null)) { (this.__APP_ID_65 = import0.ɵg()); }
    return this.__APP_ID_65;
  }
  get _IterableDiffers_66():any {
    if ((this.__IterableDiffers_66 == null)) { (this.__IterableDiffers_66 = import0.ɵl()); }
    return this.__IterableDiffers_66;
  }
  get _KeyValueDiffers_67():any {
    if ((this.__KeyValueDiffers_67 == null)) { (this.__KeyValueDiffers_67 = import0.ɵm()); }
    return this.__KeyValueDiffers_67;
  }
  get _DomSanitizer_68():import4.ɵe {
    if ((this.__DomSanitizer_68 == null)) { (this.__DomSanitizer_68 = new import4.ɵe(this.parent.get(import4.DOCUMENT))); }
    return this.__DomSanitizer_68;
  }
  get _Sanitizer_69():any {
    if ((this.__Sanitizer_69 == null)) { (this.__Sanitizer_69 = this._DomSanitizer_68); }
    return this.__Sanitizer_69;
  }
  get _HAMMER_GESTURE_CONFIG_70():import8.GestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_70 == null)) { (this.__HAMMER_GESTURE_CONFIG_70 = new import8.GestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_70;
  }
  get _EVENT_MANAGER_PLUGINS_71():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_71 == null)) { (this.__EVENT_MANAGER_PLUGINS_71 = [
      new import4.ɵDomEventsPlugin(this.parent.get(import4.DOCUMENT)),
      new import4.ɵKeyEventsPlugin(this.parent.get(import4.DOCUMENT)),
      new import4.ɵHammerGesturesPlugin(this.parent.get(import4.DOCUMENT),this._HAMMER_GESTURE_CONFIG_70)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_71;
  }
  get _EventManager_72():import4.EventManager {
    if ((this.__EventManager_72 == null)) { (this.__EventManager_72 = new import4.EventManager(this._EVENT_MANAGER_PLUGINS_71,this.parent.get(import0.NgZone))); }
    return this.__EventManager_72;
  }
  get _ɵDomSharedStylesHost_73():import4.ɵDomSharedStylesHost {
    if ((this.__ɵDomSharedStylesHost_73 == null)) { (this.__ɵDomSharedStylesHost_73 = new import4.ɵDomSharedStylesHost(this.parent.get(import4.DOCUMENT))); }
    return this.__ɵDomSharedStylesHost_73;
  }
  get _ɵDomRendererFactory2_74():import4.ɵDomRendererFactory2 {
    if ((this.__ɵDomRendererFactory2_74 == null)) { (this.__ɵDomRendererFactory2_74 = new import4.ɵDomRendererFactory2(this._EventManager_72,this._ɵDomSharedStylesHost_73)); }
    return this.__ɵDomRendererFactory2_74;
  }
  get _AnimationDriver_75():any {
    if ((this.__AnimationDriver_75 == null)) { (this.__AnimationDriver_75 = import9.ɵb()); }
    return this.__AnimationDriver_75;
  }
  get _ɵAnimationStyleNormalizer_76():any {
    if ((this.__ɵAnimationStyleNormalizer_76 == null)) { (this.__ɵAnimationStyleNormalizer_76 = import9.ɵc()); }
    return this.__ɵAnimationStyleNormalizer_76;
  }
  get _ɵAnimationEngine_77():import9.ɵa {
    if ((this.__ɵAnimationEngine_77 == null)) { (this.__ɵAnimationEngine_77 = new import9.ɵa(this._AnimationDriver_75,this._ɵAnimationStyleNormalizer_76)); }
    return this.__ɵAnimationEngine_77;
  }
  get _RendererFactory2_78():any {
    if ((this.__RendererFactory2_78 == null)) { (this.__RendererFactory2_78 = import9.ɵd(this._ɵDomRendererFactory2_74,this._ɵAnimationEngine_77,this.parent.get(import0.NgZone))); }
    return this.__RendererFactory2_78;
  }
  get _ɵSharedStylesHost_79():any {
    if ((this.__ɵSharedStylesHost_79 == null)) { (this.__ɵSharedStylesHost_79 = this._ɵDomSharedStylesHost_73); }
    return this.__ɵSharedStylesHost_79;
  }
  get _Testability_80():import0.Testability {
    if ((this.__Testability_80 == null)) { (this.__Testability_80 = new import0.Testability(this.parent.get(import0.NgZone))); }
    return this.__Testability_80;
  }
  get _Meta_81():import4.Meta {
    if ((this.__Meta_81 == null)) { (this.__Meta_81 = new import4.Meta(this.parent.get(import4.DOCUMENT))); }
    return this.__Meta_81;
  }
  get _Title_82():import4.Title {
    if ((this.__Title_82 == null)) { (this.__Title_82 = new import4.Title(this.parent.get(import4.DOCUMENT))); }
    return this.__Title_82;
  }
  get _ɵi_83():import5.ɵi {
    if ((this.__ɵi_83 == null)) { (this.__ɵi_83 = new import5.ɵi()); }
    return this.__ɵi_83;
  }
  get _BrowserXhr_84():import6.BrowserXhr {
    if ((this.__BrowserXhr_84 == null)) { (this.__BrowserXhr_84 = new import6.BrowserXhr()); }
    return this.__BrowserXhr_84;
  }
  get _ResponseOptions_85():import6.BaseResponseOptions {
    if ((this.__ResponseOptions_85 == null)) { (this.__ResponseOptions_85 = new import6.BaseResponseOptions()); }
    return this.__ResponseOptions_85;
  }
  get _XSRFStrategy_86():any {
    if ((this.__XSRFStrategy_86 == null)) { (this.__XSRFStrategy_86 = import6.ɵb()); }
    return this.__XSRFStrategy_86;
  }
  get _XHRBackend_87():import6.XHRBackend {
    if ((this.__XHRBackend_87 == null)) { (this.__XHRBackend_87 = new import6.XHRBackend(this._BrowserXhr_84,this._ResponseOptions_85,this._XSRFStrategy_86)); }
    return this.__XHRBackend_87;
  }
  get _RequestOptions_88():import6.BaseRequestOptions {
    if ((this.__RequestOptions_88 == null)) { (this.__RequestOptions_88 = new import6.BaseRequestOptions()); }
    return this.__RequestOptions_88;
  }
  get _Http_89():any {
    if ((this.__Http_89 == null)) { (this.__Http_89 = import6.ɵc(this._XHRBackend_87,this._RequestOptions_88)); }
    return this.__Http_89;
  }
  get _ScrollDispatcher_90():any {
    if ((this.__ScrollDispatcher_90 == null)) { (this.__ScrollDispatcher_90 = import8.ɵc(this.parent.get(import8.ScrollDispatcher,(null as any)),this.parent.get(import0.NgZone))); }
    return this.__ScrollDispatcher_90;
  }
  get _ɵh_91():any {
    if ((this.__ɵh_91 == null)) { (this.__ɵh_91 = import8.ɵi(this.parent.get(import8.ɵh,(null as any)),this._ScrollDispatcher_90)); }
    return this.__ɵh_91;
  }
  get _OverlayContainer_92():any {
    if ((this.__OverlayContainer_92 == null)) { (this.__OverlayContainer_92 = import8.ɵa(this.parent.get(import8.OverlayContainer,(null as any)))); }
    return this.__OverlayContainer_92;
  }
  get _ɵk_93():import8.ɵk {
    if ((this.__ɵk_93 == null)) { (this.__ɵk_93 = new import8.ɵk(this._ɵh_91)); }
    return this.__ɵk_93;
  }
  get _Overlay_94():import8.Overlay {
    if ((this.__Overlay_94 == null)) { (this.__Overlay_94 = new import8.Overlay(this._OverlayContainer_92,this.componentFactoryResolver,this._ɵk_93,this._ApplicationRef_7,this,this.parent.get(import0.NgZone))); }
    return this.__Overlay_94;
  }
  get _FocusOriginMonitor_95():any {
    if ((this.__FocusOriginMonitor_95 == null)) { (this.__FocusOriginMonitor_95 = import8.FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY(this.parent.get(import8.FocusOriginMonitor,(null as any)),this.parent.get(import0.NgZone))); }
    return this.__FocusOriginMonitor_95;
  }
  get _Platform_96():import8.Platform {
    if ((this.__Platform_96 == null)) { (this.__Platform_96 = new import8.Platform()); }
    return this.__Platform_96;
  }
  get _InteractivityChecker_97():import8.InteractivityChecker {
    if ((this.__InteractivityChecker_97 == null)) { (this.__InteractivityChecker_97 = new import8.InteractivityChecker(this._Platform_96)); }
    return this.__InteractivityChecker_97;
  }
  get _FocusTrapFactory_98():import8.FocusTrapFactory {
    if ((this.__FocusTrapFactory_98 == null)) { (this.__FocusTrapFactory_98 = new import8.FocusTrapFactory(this._InteractivityChecker_97,this.parent.get(import0.NgZone))); }
    return this.__FocusTrapFactory_98;
  }
  get _LiveAnnouncer_99():any {
    if ((this.__LiveAnnouncer_99 == null)) { (this.__LiveAnnouncer_99 = import8.ɵf(this.parent.get(import8.LiveAnnouncer,(null as any)),this.parent.get(import8.LIVE_ANNOUNCER_ELEMENT_TOKEN,(null as any)))); }
    return this.__LiveAnnouncer_99;
  }
  get _UniqueSelectionDispatcher_100():any {
    if ((this.__UniqueSelectionDispatcher_100 == null)) { (this.__UniqueSelectionDispatcher_100 = import8.ɵg(this.parent.get(import8.UniqueSelectionDispatcher,(null as any)))); }
    return this.__UniqueSelectionDispatcher_100;
  }
  get _MdDialog_101():import8.MdDialog {
    if ((this.__MdDialog_101 == null)) { (this.__MdDialog_101 = new import8.MdDialog(this._Overlay_94,this,this.parent.get(import8.MdDialog,(null as any)))); }
    return this.__MdDialog_101;
  }
  get _MdIconRegistry_102():any {
    if ((this.__MdIconRegistry_102 == null)) { (this.__MdIconRegistry_102 = import8.ICON_REGISTRY_PROVIDER_FACTORY(this.parent.get(import8.MdIconRegistry,(null as any)),this._Http_89,this._DomSanitizer_68)); }
    return this.__MdIconRegistry_102;
  }
  get _MdSnackBar_103():import8.MdSnackBar {
    if ((this.__MdSnackBar_103 == null)) { (this.__MdSnackBar_103 = new import8.MdSnackBar(this._Overlay_94,this._LiveAnnouncer_99,this.parent.get(import8.MdSnackBar,(null as any)))); }
    return this.__MdSnackBar_103;
  }
  get _ActivatedRoute_104():any {
    if ((this.__ActivatedRoute_104 == null)) { (this.__ActivatedRoute_104 = import3.ɵf(this._Router_23)); }
    return this.__ActivatedRoute_104;
  }
  get _NoPreloading_105():import3.NoPreloading {
    if ((this.__NoPreloading_105 == null)) { (this.__NoPreloading_105 = new import3.NoPreloading()); }
    return this.__NoPreloading_105;
  }
  get _PreloadingStrategy_106():any {
    if ((this.__PreloadingStrategy_106 == null)) { (this.__PreloadingStrategy_106 = this._NoPreloading_105); }
    return this.__PreloadingStrategy_106;
  }
  get _RouterPreloader_107():import3.RouterPreloader {
    if ((this.__RouterPreloader_107 == null)) { (this.__RouterPreloader_107 = new import3.RouterPreloader(this._Router_23,this._NgModuleFactoryLoader_21,this._Compiler_20,this,this._PreloadingStrategy_106)); }
    return this.__RouterPreloader_107;
  }
  get _PreloadAllModules_108():import3.PreloadAllModules {
    if ((this.__PreloadAllModules_108 == null)) { (this.__PreloadAllModules_108 = new import3.PreloadAllModules()); }
    return this.__PreloadAllModules_108;
  }
  get _ROUTER_INITIALIZER_109():any {
    if ((this.__ROUTER_INITIALIZER_109 == null)) { (this.__ROUTER_INITIALIZER_109 = import3.ɵi(this._ɵg_3)); }
    return this.__ROUTER_INITIALIZER_109;
  }
  get _APP_BOOTSTRAP_LISTENER_110():any[] {
    if ((this.__APP_BOOTSTRAP_LISTENER_110 == null)) { (this.__APP_BOOTSTRAP_LISTENER_110 = [this._ROUTER_INITIALIZER_109]); }
    return this.__APP_BOOTSTRAP_LISTENER_110;
  }
  createInternal():import1.AppModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._ErrorHandler_1 = import4.ɵa();
    this._NgProbeToken_2 = [import3.ɵb()];
    this._ɵg_3 = new import3.ɵg(this);
    this._APP_INITIALIZER_4 = [
      import0.ɵo,
      import4.ɵc(this.parent.get(import4.NgProbeToken,(null as any)),this._NgProbeToken_2),
      import3.ɵh(this._ɵg_3)
    ]
    ;
    this._ApplicationInitStatus_5 = new import0.ApplicationInitStatus(this._APP_INITIALIZER_4);
    this._ɵf_6 = new import0.ɵf(this.parent.get(import0.NgZone),this.parent.get(import0.ɵConsole),this,this._ErrorHandler_1,this.componentFactoryResolver,this._ApplicationInitStatus_5);
    this._ApplicationRef_7 = this._ɵf_6;
    this._ApplicationModule_8 = new import0.ApplicationModule(this._ApplicationRef_7);
    this._BrowserModule_9 = new import4.BrowserModule(this.parent.get(import4.BrowserModule,(null as any)));
    this._ɵba_10 = new import5.ɵba();
    this._FormsModule_11 = new import5.FormsModule();
    this._HttpModule_12 = new import6.HttpModule();
    this._SharedModule_13 = new import7.SharedModule();
    this._ɵa_14 = import3.ɵd(this.parent.get(import3.Router,(null as any)));
    this._UrlSerializer_15 = new import3.DefaultUrlSerializer();
    this._RouterOutletMap_16 = new import3.RouterOutletMap();
    this._ROUTER_CONFIGURATION_17 = {};
    this._LocationStrategy_18 = import3.ɵc(this.parent.get(import2.PlatformLocation),this.parent.get(import2.APP_BASE_HREF,(null as any)),this._ROUTER_CONFIGURATION_17);
    this._Location_19 = new import2.Location(this._LocationStrategy_18);
    this._Compiler_20 = new import0.Compiler();
    this._NgModuleFactoryLoader_21 = new import0.SystemJsNgModuleLoader(this._Compiler_20,this.parent.get(import0.SystemJsNgModuleLoaderConfig,(null as any)));
      this._ROUTES_22 = [[
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'blue'
        }
        ,
        {
          path: 'blue',
          loadChildren: 'app/blue/blue.module#BlueModule'
        }
        ,
        {
          path: 'red',
          loadChildren: 'app/red/red.module#RedModule'
        }
        ,
        {
          path: 'green',
          loadChildren: 'app/green/green.module#GreenModule'
        }
        ,
        {
          path: 'blue/:from',
          loadChildren: 'app/blue/blue.module#BlueModule'
        }
        ,
        {
          path: 'red/:from',
          loadChildren: 'app/red/red.module#RedModule'
        }
        ,
        {
          path: 'green/:from',
          loadChildren: 'app/green/green.module#GreenModule'
        }
        ,
        {
          path: '**',
          component: import13.NotFoundComponent
        }

      ]
    ];
    this._Router_23 = import3.ɵe(this._ApplicationRef_7,this._UrlSerializer_15,this._RouterOutletMap_16,this._Location_19,this,this._NgModuleFactoryLoader_21,this._Compiler_20,this._ROUTES_22,this._ROUTER_CONFIGURATION_17,this.parent.get(import3.UrlHandlingStrategy,(null as any)),this.parent.get(import3.RouteReuseStrategy,(null as any)));
    this._RouterModule_24 = new import3.RouterModule(this._ɵa_14,this._Router_23);
    this._CompatibilityModule_25 = new import8.CompatibilityModule(this.parent.get(import4.DOCUMENT,(null as any)));
    this._MdRippleModule_26 = new import8.MdRippleModule();
    this._MdSelectionModule_27 = new import8.MdSelectionModule();
    this._MdOptionModule_28 = new import8.MdOptionModule();
    this._PortalModule_29 = new import8.PortalModule();
    this._OverlayModule_30 = new import8.OverlayModule();
    this._MdAutocompleteModule_31 = new import8.MdAutocompleteModule();
    this._StyleModule_32 = new import8.StyleModule();
    this._MdButtonModule_33 = new import8.MdButtonModule();
    this._MdCardModule_34 = new import8.MdCardModule();
    this._MdChipsModule_35 = new import8.MdChipsModule();
    this._MdCheckboxModule_36 = new import8.MdCheckboxModule();
    this._MdLineModule_37 = new import8.MdLineModule();
    this._MdGridListModule_38 = new import8.MdGridListModule();
    this._PlatformModule_39 = new import8.PlatformModule();
    this._MdInputModule_40 = new import8.MdInputModule();
    this._MdListModule_41 = new import8.MdListModule();
    this._MdProgressBarModule_42 = new import8.MdProgressBarModule();
    this._MdProgressSpinnerModule_43 = new import8.MdProgressSpinnerModule();
    this._MdSelectModule_44 = new import8.MdSelectModule();
    this._A11yModule_45 = new import8.A11yModule();
    this._MdSidenavModule_46 = new import8.MdSidenavModule();
    this._ObserveContentModule_47 = new import8.ObserveContentModule();
    this._MdTabsModule_48 = new import8.MdTabsModule();
    this._MdToolbarModule_49 = new import8.MdToolbarModule();
    this._RtlModule_50 = new import8.RtlModule();
    this._MdButtonToggleModule_51 = new import8.MdButtonToggleModule();
    this._MdDialogModule_52 = new import8.MdDialogModule();
    this._MdIconModule_53 = new import8.MdIconModule();
    this._MdMenuModule_54 = new import8.MdMenuModule();
    this._MdRadioModule_55 = new import8.MdRadioModule();
    this._MdSliderModule_56 = new import8.MdSliderModule();
    this._MdSlideToggleModule_57 = new import8.MdSlideToggleModule();
    this._MdSnackBarModule_58 = new import8.MdSnackBarModule();
    this._MdTooltipModule_59 = new import8.MdTooltipModule();
    this._MaterialRootModule_60 = new import8.MaterialRootModule();
    this._BrowserAnimationsModule_61 = new import9.BrowserAnimationsModule();
    this._AppModule_62 = new import1.AppModule();
    return this._AppModule_62;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import0.ErrorHandler)) { return this._ErrorHandler_1; }
    if ((token === import0.NgProbeToken)) { return this._NgProbeToken_2; }
    if ((token === import3.ɵg)) { return this._ɵg_3; }
    if ((token === import0.APP_INITIALIZER)) { return this._APP_INITIALIZER_4; }
    if ((token === import0.ApplicationInitStatus)) { return this._ApplicationInitStatus_5; }
    if ((token === import0.ɵf)) { return this._ɵf_6; }
    if ((token === import0.ApplicationRef)) { return this._ApplicationRef_7; }
    if ((token === import0.ApplicationModule)) { return this._ApplicationModule_8; }
    if ((token === import4.BrowserModule)) { return this._BrowserModule_9; }
    if ((token === import5.ɵba)) { return this._ɵba_10; }
    if ((token === import5.FormsModule)) { return this._FormsModule_11; }
    if ((token === import6.HttpModule)) { return this._HttpModule_12; }
    if ((token === import7.SharedModule)) { return this._SharedModule_13; }
    if ((token === import3.ɵa)) { return this._ɵa_14; }
    if ((token === import3.UrlSerializer)) { return this._UrlSerializer_15; }
    if ((token === import3.RouterOutletMap)) { return this._RouterOutletMap_16; }
    if ((token === import3.ROUTER_CONFIGURATION)) { return this._ROUTER_CONFIGURATION_17; }
    if ((token === import2.LocationStrategy)) { return this._LocationStrategy_18; }
    if ((token === import2.Location)) { return this._Location_19; }
    if ((token === import0.Compiler)) { return this._Compiler_20; }
    if ((token === import0.NgModuleFactoryLoader)) { return this._NgModuleFactoryLoader_21; }
    if ((token === import3.ROUTES)) { return this._ROUTES_22; }
    if ((token === import3.Router)) { return this._Router_23; }
    if ((token === import3.RouterModule)) { return this._RouterModule_24; }
    if ((token === import8.CompatibilityModule)) { return this._CompatibilityModule_25; }
    if ((token === import8.MdRippleModule)) { return this._MdRippleModule_26; }
    if ((token === import8.MdSelectionModule)) { return this._MdSelectionModule_27; }
    if ((token === import8.MdOptionModule)) { return this._MdOptionModule_28; }
    if ((token === import8.PortalModule)) { return this._PortalModule_29; }
    if ((token === import8.OverlayModule)) { return this._OverlayModule_30; }
    if ((token === import8.MdAutocompleteModule)) { return this._MdAutocompleteModule_31; }
    if ((token === import8.StyleModule)) { return this._StyleModule_32; }
    if ((token === import8.MdButtonModule)) { return this._MdButtonModule_33; }
    if ((token === import8.MdCardModule)) { return this._MdCardModule_34; }
    if ((token === import8.MdChipsModule)) { return this._MdChipsModule_35; }
    if ((token === import8.MdCheckboxModule)) { return this._MdCheckboxModule_36; }
    if ((token === import8.MdLineModule)) { return this._MdLineModule_37; }
    if ((token === import8.MdGridListModule)) { return this._MdGridListModule_38; }
    if ((token === import8.PlatformModule)) { return this._PlatformModule_39; }
    if ((token === import8.MdInputModule)) { return this._MdInputModule_40; }
    if ((token === import8.MdListModule)) { return this._MdListModule_41; }
    if ((token === import8.MdProgressBarModule)) { return this._MdProgressBarModule_42; }
    if ((token === import8.MdProgressSpinnerModule)) { return this._MdProgressSpinnerModule_43; }
    if ((token === import8.MdSelectModule)) { return this._MdSelectModule_44; }
    if ((token === import8.A11yModule)) { return this._A11yModule_45; }
    if ((token === import8.MdSidenavModule)) { return this._MdSidenavModule_46; }
    if ((token === import8.ObserveContentModule)) { return this._ObserveContentModule_47; }
    if ((token === import8.MdTabsModule)) { return this._MdTabsModule_48; }
    if ((token === import8.MdToolbarModule)) { return this._MdToolbarModule_49; }
    if ((token === import8.RtlModule)) { return this._RtlModule_50; }
    if ((token === import8.MdButtonToggleModule)) { return this._MdButtonToggleModule_51; }
    if ((token === import8.MdDialogModule)) { return this._MdDialogModule_52; }
    if ((token === import8.MdIconModule)) { return this._MdIconModule_53; }
    if ((token === import8.MdMenuModule)) { return this._MdMenuModule_54; }
    if ((token === import8.MdRadioModule)) { return this._MdRadioModule_55; }
    if ((token === import8.MdSliderModule)) { return this._MdSliderModule_56; }
    if ((token === import8.MdSlideToggleModule)) { return this._MdSlideToggleModule_57; }
    if ((token === import8.MdSnackBarModule)) { return this._MdSnackBarModule_58; }
    if ((token === import8.MdTooltipModule)) { return this._MdTooltipModule_59; }
    if ((token === import8.MaterialRootModule)) { return this._MaterialRootModule_60; }
    if ((token === import9.BrowserAnimationsModule)) { return this._BrowserAnimationsModule_61; }
    if ((token === import1.AppModule)) { return this._AppModule_62; }
    if ((token === import0.LOCALE_ID)) { return this._LOCALE_ID_63; }
    if ((token === import2.NgLocalization)) { return this._NgLocalization_64; }
    if ((token === import0.APP_ID)) { return this._APP_ID_65; }
    if ((token === import0.IterableDiffers)) { return this._IterableDiffers_66; }
    if ((token === import0.KeyValueDiffers)) { return this._KeyValueDiffers_67; }
    if ((token === import4.DomSanitizer)) { return this._DomSanitizer_68; }
    if ((token === import0.Sanitizer)) { return this._Sanitizer_69; }
    if ((token === import4.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_70; }
    if ((token === import4.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_71; }
    if ((token === import4.EventManager)) { return this._EventManager_72; }
    if ((token === import4.ɵDomSharedStylesHost)) { return this._ɵDomSharedStylesHost_73; }
    if ((token === import4.ɵDomRendererFactory2)) { return this._ɵDomRendererFactory2_74; }
    if ((token === import14.AnimationDriver)) { return this._AnimationDriver_75; }
    if ((token === import14.ɵAnimationStyleNormalizer)) { return this._ɵAnimationStyleNormalizer_76; }
    if ((token === import14.ɵAnimationEngine)) { return this._ɵAnimationEngine_77; }
    if ((token === import0.RendererFactory2)) { return this._RendererFactory2_78; }
    if ((token === import4.ɵSharedStylesHost)) { return this._ɵSharedStylesHost_79; }
    if ((token === import0.Testability)) { return this._Testability_80; }
    if ((token === import4.Meta)) { return this._Meta_81; }
    if ((token === import4.Title)) { return this._Title_82; }
    if ((token === import5.ɵi)) { return this._ɵi_83; }
    if ((token === import6.BrowserXhr)) { return this._BrowserXhr_84; }
    if ((token === import6.ResponseOptions)) { return this._ResponseOptions_85; }
    if ((token === import6.XSRFStrategy)) { return this._XSRFStrategy_86; }
    if ((token === import6.XHRBackend)) { return this._XHRBackend_87; }
    if ((token === import6.RequestOptions)) { return this._RequestOptions_88; }
    if ((token === import6.Http)) { return this._Http_89; }
    if ((token === import8.ScrollDispatcher)) { return this._ScrollDispatcher_90; }
    if ((token === import8.ɵh)) { return this._ɵh_91; }
    if ((token === import8.OverlayContainer)) { return this._OverlayContainer_92; }
    if ((token === import8.ɵk)) { return this._ɵk_93; }
    if ((token === import8.Overlay)) { return this._Overlay_94; }
    if ((token === import8.FocusOriginMonitor)) { return this._FocusOriginMonitor_95; }
    if ((token === import8.Platform)) { return this._Platform_96; }
    if ((token === import8.InteractivityChecker)) { return this._InteractivityChecker_97; }
    if ((token === import8.FocusTrapFactory)) { return this._FocusTrapFactory_98; }
    if ((token === import8.LiveAnnouncer)) { return this._LiveAnnouncer_99; }
    if ((token === import8.UniqueSelectionDispatcher)) { return this._UniqueSelectionDispatcher_100; }
    if ((token === import8.MdDialog)) { return this._MdDialog_101; }
    if ((token === import8.MdIconRegistry)) { return this._MdIconRegistry_102; }
    if ((token === import8.MdSnackBar)) { return this._MdSnackBar_103; }
    if ((token === import3.ActivatedRoute)) { return this._ActivatedRoute_104; }
    if ((token === import3.NoPreloading)) { return this._NoPreloading_105; }
    if ((token === import3.PreloadingStrategy)) { return this._PreloadingStrategy_106; }
    if ((token === import3.RouterPreloader)) { return this._RouterPreloader_107; }
    if ((token === import3.PreloadAllModules)) { return this._PreloadAllModules_108; }
    if ((token === import3.ROUTER_INITIALIZER)) { return this._ROUTER_INITIALIZER_109; }
    if ((token === import0.APP_BOOTSTRAP_LISTENER)) { return this._APP_BOOTSTRAP_LISTENER_110; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ɵf_6.ngOnDestroy();
    (this.__ɵDomSharedStylesHost_73 && this._ɵDomSharedStylesHost_73.ngOnDestroy());
    (this.__RouterPreloader_107 && this._RouterPreloader_107.ngOnDestroy());
  }
}
export const AppModuleNgFactory:import0.NgModuleFactory<import1.AppModule> = new import0.NgModuleFactory<any>(AppModuleInjector,import1.AppModule);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRjovUHJvZ3JhbWFjaW9uL05vZGUvcHJveWVjdG9zL0FuZ3VsYXIyL21pcy1lamVtcGxvcy9Db2xvcmVzLUFuZ3VsYXI0LXJ1dGFzLWFuaWRhZGFzL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9GOi9Qcm9ncmFtYWNpb24vTm9kZS9wcm95ZWN0b3MvQW5ndWxhcjIvbWlzLWVqZW1wbG9zL0NvbG9yZXMtQW5ndWxhcjQtcnV0YXMtYW5pZGFkYXMvc3JjL2FwcC9hcHAubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts